import { cn } from 'src/lib/utils';
import type { PlatformHealthOverallStatus } from '../types/operations.types';
import {
  OVERALL_STATUS_EMOJI,
  OVERALL_STATUS_LABELS,
} from '../helpers/platform-health.helpers';

type Props = {
  status: PlatformHealthOverallStatus | string;
  showEmoji?: boolean;
};

const STATUS_COLOURS: Record<string, string> = {
  healthy: 'bg-green-100 text-green-800 border-green-200',
  pass: 'bg-green-100 text-green-800 border-green-200',
  review: 'bg-amber-100 text-amber-900 border-amber-200',
  warning: 'bg-amber-100 text-amber-900 border-amber-200',
  investigate: 'bg-red-100 text-red-800 border-red-200',
  fail: 'bg-red-100 text-red-800 border-red-200',
};

function normaliseStatus(status: string): string {
  const value = status.toLowerCase();
  if (value === 'pass') {
    return 'healthy';
  }
  if (value === 'warning') {
    return 'review';
  }
  if (value === 'fail') {
    return 'investigate';
  }
  return value;
}

export function VerificationStatusBadge({ status, showEmoji = true }: Props) {
  const normalised = normaliseStatus(status);
  const overallStatus = normalised as PlatformHealthOverallStatus;
  const label = OVERALL_STATUS_LABELS[overallStatus]
    ?? status.charAt(0).toUpperCase() + status.slice(1);
  const emoji = OVERALL_STATUS_EMOJI[overallStatus] ?? '';
  const colourClass = STATUS_COLOURS[normalised] ?? STATUS_COLOURS.healthy;

  return (
    <span
      className={cn(
        'inline-flex w-fit items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold',
        colourClass
      )}
    >
      {showEmoji && emoji ? (
        <span aria-hidden="true">
          {emoji}
        </span>
      ) : null}
      {label}
    </span>
  );
}
